import React from "react";
import { withTranslation } from "react-i18next";
import "@css/pages/hoursPlanner/hoursPlanner.css";
import ModalDelete from "@components/modals/modalDelete";

class DeleteNote extends React.Component {
  render() {
    const { isOpen, toggle, deleteNote, onClickClose, textDelete } = this.props;
    return (
      <ModalDelete
        isOpen={isOpen}
        toggle={toggle}
        content={textDelete}
        onCloseModal={onClickClose}
        handleDelete={deleteNote}
        colorBtn="green"
      />
    );
  }
}

export default withTranslation("pages.employés.anniversary")(DeleteNote);
